import { render, staticRenderFns } from "./step.vue?vue&type=template&id=07f153de&scoped=true&"
import script from "./step.vue?vue&type=script&lang=js&"
export * from "./step.vue?vue&type=script&lang=js&"
import style0 from "./step.vue?vue&type=style&index=0&id=07f153de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f153de",
  null
  
)

export default component.exports